// @utils/app-bridge.ts
import createApp from '@shopify/app-bridge'
import { Button } from '@shopify/app-bridge/actions'

let cachedApp: any = null
let cachedConfig: any = null

export const getCachedApp = () => {
  return cachedApp
}

export const getHost = (): string => {
  return (
    new URLSearchParams(window.location.search).get('host') ||
    (localStorage.getItem('shopify_host') as string)
  )
}

export const getAppBridgeInstance = (host: string) => {
  if (!host) {
    console.warn('[AppBridge] Missing host parameter')
    return null
  }

  // Check if config has changed
  const newConfig = {
    apiKey: import.meta.env.VITE_SHOPIFY_API_KEY,
    host,
    forceRedirect: true,
  }

  // Only create new instance if config changed or no instance exists
  if (!cachedApp || JSON.stringify(cachedConfig) !== JSON.stringify(newConfig)) {
    console.warn('[AppBridge] Creating new instance with config:', newConfig)
    cachedApp = createApp(newConfig)
    cachedConfig = newConfig
  }

  return cachedApp
}

export const getAppBridgeConfig = (host: string) => {
  if (!host) {
    console.warn('[AppBridge] Missing host parameter for config')
    return null
  }
  return {
    apiKey: import.meta.env.VITE_SHOPIFY_API_KEY,
    host,
    forceRedirect: true,
  }
}

export const getOkButton = (host: string) => {
  const app = getAppBridgeInstance(host)
  return app ? Button.create(app, { label: 'Ok' }) : null
}
